import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TranslateModule} from '../../shared/pipes/translate/translate.module';
import {OfferComponent} from './offer/offer.component';
import {OfferTableComponent} from './offer-table/offer-table.component';
import {OfferPreviewComponent} from './offer-table/offer-preview/offer-preview.component';
import {SortByPricePipe} from '../../shared/pipes/sort/sort-by-price';
import {HomeModule} from '../home/home.module';
import {RecaptchaModule} from 'ng-recaptcha';
import {MinimapComponent} from './offer/minimap/minimap.component';
import {OfferContactFormComponent} from './offer/offer-contact-form/offer-contact-form.component';
import {PrintOfferComponent} from './offer/print-offer/print-offer.component';
import { OfferSearchComponent } from './offer-table/offer-search/offer-search.component';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    OfferTableComponent,
    OfferComponent,
    OfferPreviewComponent,
    SortByPricePipe,
    MinimapComponent,
    OfferContactFormComponent,
    PrintOfferComponent,
    OfferSearchComponent
  ],
  imports: [
    CommonModule,
    HomeModule,
    TranslateModule,
    RecaptchaModule,
    FormsModule
  ],
  exports: [
    OfferTableComponent,
    OfferComponent,
    OfferContactFormComponent
  ]
})
export class EstatesModule {
}
